import React from 'react'
import styles from './Availability.module.scss'
import clsx from 'clsx'

interface AvailabilityIconProps {
  online: boolean
}

export const AvailabilityIcon = ({ online }: AvailabilityIconProps) => {
  return <div className={clsx(styles.circleIcon, online && styles.online)}></div>
}
